import { useRoutes } from "react-router-dom";
import ChecklistExecution from "./component/checklistExecution";
import ChecklistExecutionForm from "./component/form";

const ChecklistExecutionIndex = () => {
  const router = useRoutes([
    {
      index: true,
      element: <ChecklistExecution />,
    },
    {
      path: "add",   // ✅ relative instead of absolute
      element: <ChecklistExecutionForm />,
    },
    {
      path:"edit/:id",
      element: <ChecklistExecutionForm mode="edit"/>
    },
    {
      path:"view/:id",
      element: <ChecklistExecutionForm mode="view"/>
    }
  ]);
  return <div>{router}</div>;
};

export default ChecklistExecutionIndex;
